module.exports = __webpack_public_path__ + "media/images/nextpay-d3c362c3bc24665b769a03d64789afd8.png";